module.exports = __webpack_public_path__ + "static/media/bg-yellowM.1ceec18f.svg";